import { createContext, useContext } from 'react';
import type { TemplateDiffTemplate, TemplateDiffContentType } from '../types';

export type TemplateDiffContextState = {
  contentLeft?: TemplateDiffContentType;
  contentRight?: TemplateDiffContentType;
  isLoading: boolean;
  template?: TemplateDiffTemplate;
  currentContentIds?: number[];
};

export const defaultDiffContextState: TemplateDiffContextState = {
  isLoading: false,
};

export const TemplateDiffContext = createContext<TemplateDiffContextState>(defaultDiffContextState);

export const useTemplateDiffContext = () => useContext(TemplateDiffContext);
